import { Route, Routes } from "react-router-dom"
import { PayoutTracker } from "./pages/PayoutTracker"
import { NotFound } from "./pages/NotFound"

export default function App() {
  return (
    <Routes>
      {/* Public Tracking Page */}
      <Route path="/pago/:merchantId/:id" element={<PayoutTracker />} />

      {/* Fallback for all other routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
